import moment from "moment";
import { api } from "common";
import { Column } from "material-table";
import { useEffect, useState } from "react";
import { IUserType } from "common/src/types";
import { useTranslation } from "react-i18next";
import LockIcon from "@mui/icons-material/Lock";
import { useDispatch, useSelector } from "react-redux";
import LockOpenIcon from "@mui/icons-material/LockOpen";
import ImageColumn from "components/CustomTable/Column/ImageColumn";
import { CustomMaterialTable } from "components/CustomMaterialTable";
import { UserAccountStatusModal } from "components/modal/UserAccountStatusModal";

export default function Riders() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [data, setData] = useState<IUserType[]>();
  const [selectedUser, setSelectedUser] = useState<IUserType | undefined>(undefined);
  const [accountModalOpen, setAccountModalOpen] = useState(false);
  const usersdata = useSelector((state) => state.usersdata);
  const settings = useSelector((state) => state.settingsdata.settings);

  useEffect(() => {
    if (usersdata.staticusers) {
      setData(
        usersdata.staticusers.filter(user => user.usertype === 'customer' && user.firstName && user.email)
      );
    }
  }, [usersdata.staticusers]);

  const {
    fetchUsersOnce,
  } = api;

  useEffect(() => {
    dispatch(fetchUsersOnce());
  }, [dispatch, fetchUsersOnce]);

  if (!settings) return;

  const handleOpenAccountModal = (user: IUserType) => {
    setSelectedUser(user);
    setAccountModalOpen(true);
  };

  const columns: Column<IUserType>[] = [
    {
      field: "createdAt",
      defaultSort: "desc",
      title: t("createdAt"),
      render: (rowData) => rowData.createdAt ? moment(rowData.createdAt).format('DD/MM/YYYY HH:mm') : t("NOT_INFORMED"),
    },
    {
      field: "firstName",
      title: t("first_name"),
    },
    {
      field: "lastName",
      title: t("last_name"),
    },
    {
      field: "mobile",
      title: t("mobile"),
      render: (rowData) => rowData.mobile ? rowData.mobile : t("NOT_INFORMED"),
    },
    {
      field: "email",
      title: t("email"),
      render: (rowData) => rowData.email ? rowData.email : t("NOT_INFORMED"),
    },
    {
      field: "verifyId",
      title: t("verify_id"),
      render: (rowData) => rowData.verifyId ? rowData.verifyId : t("NOT_INFORMED"),
    },
    {
      field: "profile_image",
      title: t("profile_image"),
      render: (rowData) =>
        <ImageColumn
          type="avatar"
          altText="profile_image"
          imageUrl={rowData.profile_image}
        />
    },
    {
      field: "verifyIdImage",
      title: t("verifyid_image"),
      render: (rowData) =>
        <ImageColumn
          altText="verifyIdImage"
          imageUrl={rowData.verifyIdImage}
        />
    },
    {
      field: "verifyIdImageSelfie",
      title: t('selfie_with_document'),
      render: (rowData) =>
        <ImageColumn
          imageUrl={rowData.verifyIdImageSelfie}
          altText="verifyIdImageSelfie"
        />
    },
    {
      type: "boolean",
      field: "approved",
      title: t("account_approve"),
    },
    {
      type: "numeric",
      field: "walletBalance",
      title: t("wallet_balance"),
    },
    {
      field: "signupViaReferral",
      title: t("signup_via_referral"),
    },
    {
      field: "referralId",
      title: t("referralId"),
    }
  ];

  return (
    <>
      <CustomMaterialTable
        title={"riders"}
        columns={columns}
        data={data ?? []}
        isLoading={usersdata.loading}
        actions={[
          (rowData: IUserType) => ({
            onClick: () => handleOpenAccountModal(rowData),
            icon: rowData.accountDisabled ? LockOpenIcon : LockIcon,
            tooltip: t(rowData.accountDisabled ? "ENABLE_ACCOUNT" : "DISABLE_ACCOUNT"),
          }),
        ]}
      />

      <UserAccountStatusModal
        open={accountModalOpen}
        selectedUser={selectedUser}
        onClose={() => setAccountModalOpen(false)}
        onStatusChange={() => setTimeout(() => { window.location.reload() }, 1000)}
      />
    </>
  );
}